export default class VariantMediaData {
    public id: number;
    public variantId: number;
    public typeId: number;
    public storageGuid: string;
    public filename: string;
    public persisted: boolean = false;
    public toBeDeleted: boolean = false;
    public file?: File = null;

    constructor(
        id: number,
        variantId: number,
        typeId: number,
        storageGuid: string,
        filename: string,
        persisted: boolean,
        file?: File,
    ) {
        this.id = id;
        this.variantId = variantId;
        this.typeId = typeId;
        this.storageGuid = storageGuid;
        this.filename = filename;
        this.file = file ? file : null;
        this.persisted = persisted;
    }

    public setFileData(file: File) {
        this.file = file;
    }

    public dataEquals(variantMedia: VariantMediaData): boolean {
        // Check if this object's values are equal to the given object's
        if (
            this.id === variantMedia.id &&
            this.variantId === variantMedia.variantId &&
            this.typeId === variantMedia.typeId &&
            this.storageGuid === variantMedia.storageGuid &&
            this.filename === variantMedia.filename &&
            this.file === variantMedia.file
        ) {
            return false;
        }
    }

    public markForDeletion() {
        this.toBeDeleted = true;
    }
}
